import { render } from "./pacienteList.vue?vue&type=template&id=1d5ee1cd&scoped=true"
import script from "./pacienteList.vue?vue&type=script&lang=js"
export * from "./pacienteList.vue?vue&type=script&lang=js"

import "./pacienteList.vue?vue&type=style&index=0&id=1d5ee1cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5ee1cd"]])

export default __exports__